import styled from 'styled-components';
import { breakpoints } from '@/layouts/breakpoints';

const StyledContact = styled.div`
  overflow-x: hidden;

  .hero {
    width: calc(100vw - 40px);
    height: 50vh;
    min-height: 400px;
    overflow: hidden;
    position: relative;
    padding: 40px;
    border-bottom: 1px solid rgba(var(--greyr), 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    .graphic {
      overflow: hidden;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0.15;
      z-index: 1;
      pointer-events: none;
      video{
        position: absolute;
        min-height: 100%;
        width: 70%;
        top: 0%;
        left: -15vw;
        &.right{
          transform: rotate(180deg);
          left: unset;
          right: -15vw;
        }
     }
    }

    .content {
      position: relative;
      z-index: 2;
      pointer-events: none;
      max-width: 800px;

      h1 {
        font-size: 64px;
        line-height: 1.1;
        margin-bottom: 24px;
        color: var(--black);
      }

      p {
        font-size: 18px;
        color: var(--grey);
        line-height: 1.6;
        max-width: 600px;
        margin: 0 auto;
      }
    }
  }

  @media (max-width: 1024px) {
    .hero {
      padding: 30px 20px;
      height: 40vh;

      .content h1 {
        font-size: 48px;
      }
    }
  }

  @media (max-width: ${breakpoints.xsmall}) {
    .hero {
      padding: 20px 16px;
      height: auto;
      min-height: 35vh;

      .content {
        h1 {
          font-size: 32px;
          margin-bottom: 16px;
        }

        p {
          font-size: 14px;
          max-width: 100%;
        }
      }
    }
  }
`;

export default StyledContact;
